import type {AxiosError} from "axios";

/** Officer break/shift mutations — path is `break` or `shift` (first segment). */
export function isShiftOrBreakHttpPath(url?: string): boolean {
  const path = normalizeHttpPathTag(url);
  const segment = path.split("/")[0] ?? "";
  return segment === "break" || segment === "shift";
}

export function normalizeHttpPathTag(url?: string): string {
  if (!url) return "";

  const withoutQuery = url.split("?")[0]?.split("#")[0] ?? url;
  let path = withoutQuery;

  try {
    if (withoutQuery.startsWith("http://") || withoutQuery.startsWith("https://")) {
      path = new URL(withoutQuery).pathname;
    }
  } catch {
    // fall through
  }

  return path.replace(/^\/api\/v\d+\/?/, "").replace(/^\//, "");
}

export type HttpContext = {
  httpMethod?: string;
  httpPath?: string;
  httpStatus?: string;
};

export function resolveHttpStatusTag(error: AxiosError): string {
  const status = error.response?.status;
  if (typeof status === "number") return String(status);
  if (!error.response && error.request) return "0";
  return "0";
}

export function extractHttpContextFromAxios(error: AxiosError): HttpContext {
  const method = error.config?.method?.toUpperCase();
  const path = normalizeHttpPathTag(error.config?.url);

  return {
    httpMethod: method || undefined,
    httpPath: path || undefined,
    httpStatus: resolveHttpStatusTag(error),
  };
}
